import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import { VueEditor } from "vue2-editor"
import Multiselect from 'vue-multiselect/src/Multiselect.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  name: 'PlacesForm',
  computed,
  data,
  methods,
  mounted,
  components: {
    VueEditor,
    Multiselect,
    Cropper,
  }
}
